import { Component, OnInit, Input } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { GlobalDataService } from 'src/app/core/global-data/global-data.service';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-product-component-list',
  templateUrl: './product-component-list.component.html',
  styleUrls: ['./product-component-list.component.scss'],
})
export class ProductComponentListComponent implements OnInit {
 
  private unsubNotifier = new Subject<void>();
  
  @Input() class: string = ''; // classe css optionnelle pour le conteneur principal
  @Input() productComponentList: any[] = []; // liste des product components à afficher
  @Input() canSeePrice: boolean = false; // indique si l'utilisateur peut voir les prix ou pas
  
  public noteList: any[] = [];
  public productList: any[] = [];
  public deductProductComponentFromBudget: boolean = false;

  constructor(
    private globalDataService: GlobalDataService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // set deductProductComponentFromBudget
    this.globalDataService.userGroupRestrictions.pipe(takeUntil(this.unsubNotifier)).subscribe(ugr => {
      this.deductProductComponentFromBudget = ugr.deductProductComponentFromBudget;
    });
    
    // spliter la liste en deux : les notes et les produits
    this.productComponentList.forEach((component) => {
      if (component.childProductComponentType === 'AddCommentToParent') {
        this.noteList.push(component);
      } else if (component.childProductComponentType === 'AddProductItemInNewLine') {
        this.productList.push(component);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubNotifier.next();
    this.unsubNotifier.unsubscribe();
  }

}

